module.exports = __webpack_public_path__ + "static/shotlists_group_mobile-0ca9d7398e85d649f32fa10402bc3799.png";